import { useTranslation } from 'react-i18next';
import { useDesign } from '@/hooks/useDesigns';
import { useDesignStore } from '@/stores';

/**
 * The publish step's explanation of the header badge: the design changed
 * since its last publish, and print and shop take the changes only once
 * the seller publishes again.
 */
export function UnpublishedChangesNotice() {
  const { t } = useTranslation();
  const designId = useDesignStore((state) => state.designId);
  const { data: design } = useDesign(designId ?? undefined);

  if (!design?.hasUnpublishedChanges) return null;
  return (
    <div
      role="status"
      className="rounded-control bg-warning px-4 py-3 text-sm text-ink"
    >
      <p className="font-semibold">
        {t('creator.publish.unpublishedChangesTitle')}
      </p>
      <p className="mt-1">{t('creator.publish.unpublishedChangesHint')}</p>
    </div>
  );
}
